import {Icon, Spin} from 'antd';
import React from "react";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

export function Spinner(props){
  return(
    <Spin indicator={antIcon} />
  )
}
